/**
 * Lab401: Accessories (complementary products)
 *
 * No AJAX per accessory — all items added in one request when the user
 * clicks "Add to Cart". Each accessory row has purely client-side
 * "+Add" / quantity controls that track selection state.
 *
 * On form submit, the script intercepts fetch() calls to /cart/add.js
 * and appends selected accessories to the items payload. This works
 * with any cart handler (UpCart, AddToCartFlyout, native form, etc.).
 */
(function() {

  function initAccessories(root) {
    root = root || document;
    root.querySelectorAll('[data-accessory-row]').forEach(function(row) {
      if (row._accessoryInit) return;
      row._accessoryInit = true;

      var addBtn = row.querySelector('[data-accessory-add]');
      var qtyWrap = row.querySelector('[data-accessory-qty]');
      var minusBtn = row.querySelector('[data-accessory-minus]');
      var plusBtn = row.querySelector('[data-accessory-plus]');
      var countEl = row.querySelector('[data-accessory-count]');
      if (!addBtn) return;

      row._accessoryQty = 0;

      function setQty(n) {
        row._accessoryQty = n;
        if (n > 0) {
          addBtn.style.display = 'none';
          qtyWrap.style.display = 'flex';
          countEl.textContent = n;
        } else {
          addBtn.style.display = '';
          qtyWrap.style.display = 'none';
        }
      }

      addBtn.addEventListener('click', function() { setQty(1); });
      if (plusBtn) plusBtn.addEventListener('click', function() { setQty(row._accessoryQty + 1); });
      if (minusBtn) minusBtn.addEventListener('click', function() { setQty(Math.max(0, row._accessoryQty - 1)); });
    });
  }

  /**
   * Collect selected accessories as an array of {id, quantity} objects.
   */
  function getSelectedAccessories() {
    var items = [];
    document.querySelectorAll('[data-accessory-row]').forEach(function(row) {
      var qty = row._accessoryQty || 0;
      if (qty > 0) {
        var vid = row.getAttribute('data-variant-id');
        items.push({ id: parseInt(vid, 10), quantity: qty });
      }
    });
    return items;
  }

  /**
   * Reset all accessory rows back to "+Add" state.
   */
  function resetAccessories() {
    document.querySelectorAll('[data-accessory-row]').forEach(function(row) {
      if (row._accessoryQty > 0) {
        row._accessoryQty = 0;
        var addBtn = row.querySelector('[data-accessory-add]');
        var qtyWrap = row.querySelector('[data-accessory-qty]');
        if (addBtn) addBtn.style.display = '';
        if (qtyWrap) qtyWrap.style.display = 'none';
      }
    });
  }

  /**
   * Monkey-patch fetch() to intercept /cart/add.js requests.
   * When accessories are selected, append them to the items array.
   * Works with any cart handler (UpCart, AddToCartFlyout, native).
   */
  function hookFetch() {
    var origFetch = window.fetch;
    window.fetch = function(url, opts) {
      // Only intercept POST to /cart/add.js
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      if (urlStr.indexOf('/cart/add') === -1 || !opts || opts.method !== 'POST') {
        return origFetch.apply(this, arguments);
      }

      var accessories = getSelectedAccessories();
      if (accessories.length === 0) {
        return origFetch.apply(this, arguments);
      }

      // Parse the existing body
      var body;
      try {
        body = typeof opts.body === 'string' ? JSON.parse(opts.body) : null;
      } catch (e) {
        body = null;
      }

      if (body && body.items && Array.isArray(body.items)) {
        // Append accessories to existing items array
        accessories.forEach(function(a) { body.items.push(a); });
        opts = Object.assign({}, opts, { body: JSON.stringify(body) });
      } else if (body) {
        // Single-item format — convert to multi-item
        var mainId = body.id || body.variant_id;
        var mainQty = parseInt(body.quantity, 10) || 1;
        if (mainId) {
          var items = [{ id: parseInt(mainId, 10), quantity: mainQty }];
          accessories.forEach(function(a) { items.push(a); });
          opts = Object.assign({}, opts, { body: JSON.stringify({ items: items }) });
        }
      }

      // Reset accessories after the request succeeds
      var result = origFetch.apply(this, [url, opts]);
      result.then(function(response) {
        if (response.ok) resetAccessories();
      });
      return result;
    };
  }

  // Init
  function init() {
    initAccessories();
    hookFetch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
